import { Link } from 'react-router'

// Labels that say what the numbers and summaries are: AI-extracted calls,
// hypothetical performance, no investment advice. The full explanation lives
// on /methodology, which every label links to.

export const CONFLICTS =
  'PodcastAlpha isn’t paid by any podcast it scores, doesn’t sell picks, and its operators don’t trade on calls before they’re published.'

export const NOT_ADVICE = 'Not investment advice.'

// Next to a recommendation's thesis, which is the extractor's paraphrase.
export function AiTag() {
  return <span className="ai-tag" data-testid="ai-tag">AI summary</span>
}

export function AiNote() {
  return (
    <p className="ai-note" data-testid="ai-note">
      Calls are extracted from the episode by AI and may contain errors. The clip is the source of truth.{' '}
      <Link to="/methodology">How this works</Link>
    </p>
  )
}

// Under the "if you'd followed every pick" curve.
export function PerformanceNote({ benchmark }: { benchmark: boolean }) {
  return (
    <p className="perf-note" data-testid="performance-note">
      Hypothetical: no one traded this. Each scored pick gets an equal share from the first open after its episode
      and is never sold. Price-only, so no dividends, fees or slippage.
      {benchmark && ' The dashed line puts the same money into SPY on the same days.'} Past performance doesn’t predict
      future results. <Link to="/methodology">Methodology</Link>
    </p>
  )
}

export function SiteFooter() {
  return (
    <footer className="site-foot" data-testid="site-footer">
      <Link to="/methodology">Methodology</Link>
      <span aria-hidden>·</span>
      <span>{NOT_ADVICE}</span>
    </footer>
  )
}
